import { useParams } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { getItem } from '../../../../../api/app/getters/getItem.js'
import ViewSprawozdanieFormS1 from './s1/ViewSprawozdanieForm.jsx'
import ViewSprawozdanieFormS2 from './s2/ViewSprawozdanieForm.jsx'
import { Spinner } from 'react-bootstrap'

const ViewSprawozdanieForm = () => {
    const { rejestrId, sprawozdanieId } = useParams()
    
    const wersja = sprawozdanieId ? `/${sprawozdanieId}` : ''
    const dataUrl = `oper/sprawozdanie/${rejestrId}${wersja}`

    // Pobierz dane sprawozdania aby uzyskać kategorię
    const { data, isLoading } = useQuery({
        queryKey: [`sprawozdanie_kategoria_${rejestrId}_${sprawozdanieId}`],
        queryFn: () => getItem(dataUrl),
        enabled: !!rejestrId,
        staleTime: 5 * 60 * 1000, // 5 minut
    })

    const kategoria = data?.kategoria

    if (isLoading) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ minHeight: 300 }}>
                <Spinner animation="border" role="status">
                    <span className="visually-hidden">Ładowanie...</span>
                </Spinner>
            </div>
        )
    }

    if (kategoria === 'B') {
        return <ViewSprawozdanieFormS2 />
    }

    return <ViewSprawozdanieFormS1 />
}

export default ViewSprawozdanieForm
